import apiClient from '../client';

const PURCHASE_ORDER_BASE = `/digitization/v1/purchase-order`;
const WAREHOUSE_BASE = `/traceability/v1/center/get_warehouse_list`;
const SUPPLIER_BASE = `/digitization/v1/supplier/list`;
const PRODUCT_REPORT_BASE = `/digitization/v1/product/report`;

export const purchaseOrderApi = {
  getNextPoCode: () => apiClient.get(`${PURCHASE_ORDER_BASE}/next-code`),
  createPurchaseOrder: data => apiClient.post(PURCHASE_ORDER_BASE, data),
  updatePurchaseOrder: (id, data) =>
    apiClient.put(`${PURCHASE_ORDER_BASE}/${id}`, data),
  getPurchaseOrder: id => apiClient.get(`${PURCHASE_ORDER_BASE}/${id}`),
  deletePurchaseOrder: id => apiClient.delete(`${PURCHASE_ORDER_BASE}/${id}`),
  getPurchaseOrderReport: params =>
    apiClient.post(`${PURCHASE_ORDER_BASE}/report`, params),
  getWarehouses: () => apiClient.get(WAREHOUSE_BASE),
  getSuppliers: () => apiClient.get(SUPPLIER_BASE),
  getProductReport: params => apiClient.post(PRODUCT_REPORT_BASE, params)
};

export default purchaseOrderApi;
